// extracted by mini-css-extract-plugin
export default {"chartHeader":"percentageBarChart_chartHeader__gW+j1","innerCard":"percentageBarChart_innerCard__ovTcU"};